import { getApi } from '../api/storeFront';
import { parseStoreCategory, getHierarchy, getListOfSubHierarchy, getFilteredCollection, } from '../utils';
const getSubCategories = async ({ id, count, cursor, filter, includeCurrentCategory }, logger) => {
    const urlParams = new URLSearchParams();
    urlParams.append('count', count.toString());
    urlParams.append('cursor', cursor.toString());
    const response = await getApi(`/collections?${urlParams.toString()}`, logger);
    const menuResonseJson = await getApi(`/classification?handle=${filter}`, logger);
    const menuHirarchy = getHierarchy(menuResonseJson.data, id?.toString());
    if (includeCurrentCategory) {
        menuHirarchy?.items.push({ resourceId: menuHirarchy.resourceId });
    }
    const listOfSubHierarchy = getListOfSubHierarchy(menuHirarchy?.items);
    const categories = getFilteredCollection(listOfSubHierarchy, response?.data);
    return {
        data: [...parseStoreCategory(categories)],
    };
};
export default getSubCategories;
